import React, { useEffect, useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, Sparkles } from 'lucide-react';
import { svcListGallery } from '@/services/entitiesService';

export default function GalleryLooks() {
  const [items, setItems] = useState([]);
  const trackRef = useRef(null);

  useEffect(() => {
    svcListGallery().then(setItems).catch(() => setItems([]));
  }, []);

  const scrollBy = (dir) => {
    if (!trackRef.current) return;
    trackRef.current.scrollBy({ left: dir * trackRef.current.clientWidth * 0.8, behavior: 'smooth' });
  };

  if (!items || items.length === 0) return null;

  return (
    <section className="my-10" data-testid="gallery-looks">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-end justify-between mb-4">
          <div>
            <span className="inline-flex items-center gap-1 text-xs font-bold text-[#1B2A4A] bg-yellow-100 px-2 py-1 rounded-full uppercase"><Sparkles size={12} /> Galería</span>
            <h3 className="text-2xl md:text-3xl font-extrabold text-[#1B2A4A] mt-2">Looks &amp; clientas reales</h3>
            <p className="text-sm text-slate-500">Nuestras clientas luciendo su BIGTIME.</p>
          </div>
          <div className="hidden md:flex gap-2">
            <button onClick={() => scrollBy(-1)} className="w-10 h-10 rounded-full bg-white border shadow-sm hover:bg-slate-50" data-testid="gallery-prev"><ChevronLeft size={18} className="mx-auto" /></button>
            <button onClick={() => scrollBy(1)} className="w-10 h-10 rounded-full bg-white border shadow-sm hover:bg-slate-50" data-testid="gallery-next"><ChevronRight size={18} className="mx-auto" /></button>
          </div>
        </div>
        <div ref={trackRef} className="flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 -mx-4 px-4">
          {items.map((it) => (
            <figure key={it.id} className="min-w-[240px] md:min-w-[300px] snap-start rounded-2xl overflow-hidden bg-white border shadow-sm">
              <div className="aspect-[3/4] bg-slate-100 overflow-hidden">
                <img src={it.image} alt={it.caption || 'Cliente BIGTIME'} className="w-full h-full object-cover hover:scale-105 transition duration-500" loading="lazy" />
              </div>
              {(it.caption || it.customer_name) && (
                <figcaption className="p-3">
                  {it.customer_name && <div className="font-bold text-sm text-[#1B2A4A]">{it.customer_name}{it.city ? ` · ${it.city}` : ''}</div>}
                  {it.caption && <div className="text-xs text-slate-600 mt-0.5">{it.caption}</div>}
                </figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
